import { Auth0ModeOptions, AuthMode } from '@Modules/auth_module';
import { InlineTemplate, ModalTemplate, Template } from '.';
import { UIUtil } from '@Shared/utils';
import { DisplayType } from '../display';

export function createTemplate(
  modeOptions: Extract<Auth0ModeOptions, { type: AuthMode.Embedded }>,
): Template {
  if (modeOptions.options.display.type === DisplayType.Inline) {
    const selector = modeOptions.options.display.selector;
    const exists = UIUtil.doesElementExist(selector);
    if (exists) {
      //return new Template(modeOptions.options.display.selector, modeOptions.options.display.modalAsBackup);
      return new InlineTemplate(selector);
    } else if (modeOptions.options.display.modalAsBackup) {
      //if the selector doesn't exist, but modalAsBackup is set to true, then we will return a modal template.
      return new ModalTemplate();
    } else {
      throw new Error(
        `Selector ${selector} does not exist and modalAsBackup is set to false.`,
      );
    }
  }
  //using if and not else if because if the selector for the Inline template doesn't exist, we want to fall back to the modal template.
  if (modeOptions.options.display.type === DisplayType.Modal) {
    return new ModalTemplate();
  }

  throw new Error('Invalid display type. Must be either Modal or Inline.');
}
